import { styled } from '@project44/manifest-ds';

export const Content = styled('div', {
  marginRight: '16px',
  color: '$text-contrast',
});

export const CloseButton = styled('div', {
  color: '$text-contrast',
  cursor: 'pointer',
});
